module.exports = __webpack_public_path__ + "img/ayun-dispatch.7e980e37.svg";